import {Component, OnInit, Output, EventEmitter, signal} from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { environment } from 'projects/store/src/environments/environment';
import { UserValidatorService } from 'projects/store/src/app/services/api/v1/user-validator.service';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {PathNavigationService} from 'projects/store/src/app/services/api/v1/path-navigation.service';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpStatusCode} from "@angular/common/http";
import {CustomMessageService, ResponseHttpError, ResponseHttpSuccess, UtilService} from "library";

@Component({
  selector: 'app-update-client-information',
  templateUrl: './update-client-information.component.html'
})
export class UpdateClientInformationComponent implements OnInit {
  routesBreadcrumbs = ['VENTAS', 'Autogestión', 'Actualizar teléfono'];
  form: FormGroup;
  country = environment.global.country;
  requestId: string;
  currentUrl!: string;
  phone!: string;
  data = signal<any>({});
  categoryCode: string;
  request: any;
  flowCode: string;
  @Output() nextStepEvent = new EventEmitter();


  constructor(
              private utilService: UtilService,
              private userValidatorService: UserValidatorService,
              private requestService: RequestService,
              private route: ActivatedRoute,
              private customMessageService: CustomMessageService,
              private router: Router,
              private pathNavigationService: PathNavigationService,
            ) {

      this.form = this.createFormGroup();
      this.requestId = this.route.snapshot.params['request_id'];
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.request = this.requestService.request;

  }

  ngOnInit(): void {

    this.getRequest();
  }

  private createFormGroup(): FormGroup {
    return new FormGroup({
      phone: new FormControl(
        null,
        {
          validators: [
            Validators.required,
            Validators.minLength(this.country.minPhoneNumberCharacters),
            Validators.maxLength(this.country.maxPhoneNumberCharacters)
          ],
          asyncValidators: [this.userValidatorService.phoneServiceVerification(),this.userValidatorService.phoneServiceExistValidator(this.requestId)],
          updateOn: 'blur'
        }
      )
    });
  }



  isSubmitDisabled(): boolean {

    const phone: string = (this.form.get('phone')?.value || '');
    const mask = this.country.phoneCountryMask;
    const formattedPhone = this.utilService.formatPhoneNumber(phone, mask);
    const length = formattedPhone.length;

    if (length == this.country.maxPhoneNumberCharacters && this.form.untouched ) {
      return false;
    }

    if (
      length < this.country.minPhoneNumberCharacters ||
      length > this.country.maxPhoneNumberCharacters
    ) {
      return true;
    }

    return this.form.invalid || this.form.pending;
  }

  onSubmit(): void {

    if (this.form.invalid && this.isSubmitDisabled()) {
      return;
    }

    const rawPhone = this.form.get('phone')?.value || '';
    const phone = rawPhone
      .replace(this.country.phoneCountryCode, '')
      .replace(/[^0-9+\s]/g, '')
      .trim();

    const data = { person: { phone } };
    this.updateRequest(data);
  }

  getRequest(): void {
    if (this.request.person?.phone !== undefined) {
      this.phone = this.request.person.phone;
      this.data.set(this.request);
      this.form.patchValue({ phone: `${this.country.phoneCountryCode} ${this.phone}` });
    }
    this.utilService.disablePageLoading();
  }

  updateRequest(data:any) {

    this.requestService.update(this.requestId, data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if (resp.status == HttpStatusCode.NoContent){

          this.onNextStep();

        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        if ( error.status === HttpStatusCode.Locked) {
          this.handleRequestLocked(error as any);
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
      }
    })
  }

  getCurrentUrl(): string {
    return window.location.href;
  }

  get f(){
    return this.form.controls;
  }

  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  private handleRequestLocked(resp: any): void {
    const messageError = resp.error?.message ?? 'Solicitud no disponible';
    const attemptedUrl = this.getCurrentUrl();
    const state = { attemptedUrl, messageError };

    this.pathNavigationService.navigateToRequestNotAvailable(this.flowCode, state);
  }
}
